import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import useAuth from '@/composables/useAuth';
import { FEATURE_FLAG } from '@/constants/feature_flags';
import { useBillingStore, useFeatureFlagStore } from '@/stores';
import { computeCreditLimitStatus } from '@/utils/creditLimitStatus';

export default function useAgentAccess() {
  const { hasScope } = useAuth();
  const { hasFeatureFlag } = useFeatureFlagStore();
  const { isFreeTier, isLegacyConnectorPPv5, creditsUsed, creditLimit } =
    storeToRefs(useBillingStore());

  const canManageAgents = computed(() => hasScope('write:agents'));

  const isOutOfCredits = computed(
    () =>
      !isFreeTier.value &&
      !isLegacyConnectorPPv5.value &&
      hasFeatureFlag(FEATURE_FLAG.TEMP_AGENTS_CREDIT_METERING) &&
      computeCreditLimitStatus(creditsUsed.value, creditLimit.value) ===
        'danger',
  );

  const canUseTemplates = computed(
    () => canManageAgents.value && !isOutOfCredits.value,
  );

  return { canManageAgents, isOutOfCredits, canUseTemplates };
}
